module.exports = __webpack_public_path__ + "img/3.c2441c0c.png";